export type UnauthorizedDescription = 'Unauthorized IP address' | 'Unauthorized';

/**
 * Maps various auth-related errors (WS connection or GraphQL) to a user-facing description.
 * - connection_error with "Unauthorized IP Address" payload -> "Unauthorized IP address"
 * - 403 / FORBIDDEN / "forbidden" -> "Unauthorized IP address"
 * - explicit "unauthorized ip" in message -> "Unauthorized IP address"
 * - default -> "Unauthorized"
 */
export function mapUnauthorizedError(error: unknown): UnauthorizedDescription {
  const err: any = error as any;

  // Handle WebSocket connection_error format: {"type":"connection_error","payload":"Unauthorized IP Address"}
  if (err?.type === 'connection_error' && err?.payload) {
    const payload = String(err.payload).toLowerCase();
    if (payload.includes('unauthorized ip')) {
      return 'Unauthorized IP address';
    }
  }

  const toStr = () => (typeof err?.toString === 'function' ? err.toString() : '');
  const message = String(err?.message || err?.networkError?.message || toStr() || '');
  const status = err?.statusCode ?? err?.networkError?.statusCode ?? err?.networkError?.status;
  const lower = message.toLowerCase();

  if (
    status === 403 ||
    lower.includes('forbidden') ||
    lower.includes('status code 403') ||
    lower.includes('unauthorized ip')
  ) {
    return 'Unauthorized IP address';
  }

  return 'Unauthorized';
}
